<template>
  <div class="w-full flex justify-center mt-20">
    <vue-loaders v-if="verifing" name="square-spin" color="#ed8936" scale=".5"></vue-loaders>
    <div v-if="!verifing" class="flex flex-col items-center">
      <span class="font-bold text-2xl mb-8">Pagina non trovata</span>
      <p class=" text-center text-lg opacity-75" :style="{ maxWidth: '64ch' }">
        La risorsa che stai cercando di raggiungere non è disponibile.
        <br />
        Verifica l'indirizzo al quale ti sei collegato.
      </p>
      <router-link to="/" class="mt-8 text-i4m-orange">Torna alla pagina iniziale</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',

  async mounted() {
    this.verifing = false;
  },

  data() {
    return {
      verifing: true
    };
  }
};
</script>

<style lang="css" scoped></style>
